import { render, staticRenderFns } from "./SkeepersCarousel.vue?vue&type=template&id=9d4f9d9e"
import script from "./SkeepersCarousel.vue?vue&type=script&lang=js"
export * from "./SkeepersCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports